module.exports = __webpack_public_path__ + "img/index-product-scan-blue.54719d24.png";